/* eslint-disable @typescript-eslint/no-explicit-any */
import { getLocales } from 'utils/marketExtensionConfig';
interface Locales {
  [key: string]: string;
}

export const i18n = () => {
  const marketExtensionsLocalesData = getLocales()?.locales ?? {};
  const localesData = (marketExtensionsLocalesData?.mappedLocales as any as Locales) || {};

  return {
    locales: Object.keys(localesData),
    defaultLocale: marketExtensionsLocalesData.defaultLocale as string,
  };
};

export const getLocale = (currentLocale: string): string => {
  const marketExtensionsLocalesData = getLocales()?.locales ?? {};
  const localesData = (marketExtensionsLocalesData.mappedLocales as any as Locales) || {};
  const defaultKey = marketExtensionsLocalesData.defaultLocale as keyof Locales;
  const defaultLocale = localesData[defaultKey];

  if (!currentLocale) {
    return defaultLocale;
  }
  const baseLocale = currentLocale.toLowerCase().split('-')[0];
  const matched = localesData[baseLocale];

  return matched || defaultLocale;
};
